"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBusinessData = getBusinessData;
exports.getBusinessList = getBusinessList;
exports.getBusinessNData = getBusinessNData;
exports.getExprot = getExprot;
exports.getOperationData = getOperationData;
exports.getProductData = getProductData;
exports.getProductRanking = getProductRanking;
exports.getProductTrend = getProductTrend;
exports.getPurchaseData = getPurchaseData;
exports.getUserClickApi = getUserClickApi;
exports.getUserData = getUserData;
exports.overviewAccessApi = overviewAccessApi;
exports.overviewCartProductTopApi = overviewCartProductTopApi;
exports.overviewDesignAuthPageApi = overviewDesignAuthPageApi;
exports.overviewDurationDistributionApi = overviewDurationDistributionApi;
exports.overviewHourlyPayTrendApi = overviewHourlyPayTrendApi;
exports.overviewHourlyTrafficTrendApi = overviewHourlyTrafficTrendApi;
exports.overviewHourlyTrendApi = overviewHourlyTrendApi;
exports.overviewTrafficDataApi = overviewTrafficDataApi;
exports.overviewTransactionDataApi = overviewTransactionDataApi;
exports.overviewUserDataApi = overviewUserDataApi;
exports.productDataApi = productDataApi;
exports.productRankApi = productRankApi;
exports.productTrendApi = productTrendApi;
exports.searchMsgClickApi = searchMsgClickApi;
exports.tradeDataApi = tradeDataApi;
exports.tradeOverviewApi = tradeOverviewApi;
exports.tradeTrendApi = tradeTrendApi;
exports.userAreaData = userAreaData;
exports.userChannelData = userChannelData;
exports.userOverviewData = userOverviewData;
exports.userOverviewListApi = userOverviewListApi;
exports.userSexData = userSexData;
exports.userTotalData = userTotalData;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

/**
 * 商品统计数据
 * @param pram
 */
function productDataApi(params) {
  return (0, _request.default)({
    url: "/admin/statistics/product/data",
    method: 'GET',
    params: params
  });
}

/**
 * 商品排行数据
 * @param pram
 */
function productRankApi(params) {
  return (0, _request.default)({
    url: "/admin/statistics/product/ranking",
    method: 'GET',
    params: params
  });
}

/**
 * 商品趋势数据
 * @param pram
 */
function productTrendApi(params) {
  return (0, _request.default)({
    url: "/admin/statistics/product/trend",
    method: 'GET',
    params: params
  });
}

/**
 * 交易统计数据
 * @param pram
 */
function tradeDataApi() {
  return (0, _request.default)({
    url: "/admin/statistics/trade/data",
    method: 'GET'
  });
}

/**
 * 交易概览
 * @param pram
 */
function tradeOverviewApi(params) {
  return (0, _request.default)({
    url: "/admin/statistics/trade/overview",
    method: 'GET',
    params: params
  });
}

/**
 * 交易趋势
 * @param pram
 */
function tradeTrendApi(params) {
  return (0, _request.default)({
    url: "/admin/statistics/trade/trend",
    method: 'GET',
    params: params
  });
}

/**
 * 用户总数据
 * @param pram
 */
function userTotalData() {
  return (0, _request.default)({
    url: "/admin/statistics/user/total/data",
    method: 'GET'
  });
}

/**
 * 用户区域数据
 * @param pram
 */
function userAreaData() {
  return (0, _request.default)({
    url: "/admin/statistics/user/area",
    method: 'GET'
  });
}

/**
 * 用户渠道数据
 * @param pram
 */
function userChannelData() {
  return (0, _request.default)({
    url: "/admin/statistics/user/channel",
    method: 'GET'
  });
}

/**
 * 用户概览
 * @param pram
 */
function userOverviewData(params) {
  return (0, _request.default)({
    url: "/admin/statistics/user/overview",
    method: 'GET',
    params: params
  });
}

/**
 * 用户性别数据
 * @param pram
 */
function userSexData() {
  return (0, _request.default)({
    url: "/admin/statistics/user/sex",
    method: 'GET'
  });
}

/**
 * 用户概览列表
 * @param pram
 */
function userOverviewListApi(params) {
  return (0, _request.default)({
    url: "/admin/statistics/user/overview/list",
    method: 'GET',
    params: params
  });
}

// 以下是数据埋点统计接口

/**
 * 控制台-运营
 * @param pram
 */
function getOperationData(params) {
  return (0, _request.default)({
    url: "/admin/statistics/console/getOperationData",
    method: 'GET',
    params: params
  });
}

/**
 * 控制台-采购
 * @param pram
 */
function getPurchaseData(params) {
  return (0, _request.default)({
    url: "/admin/statistics/console/getPurchaseData",
    method: 'GET',
    params: params
  });
}

/**
 * 交易统计
 * @param pram
 */
function getBusinessData(params) {
  return (0, _request.default)({
    url: "/admin/statistics/console/getBusinessData",
    method: 'GET',
    params: params
  });
}

/**
 * 交易统计
 * @param pram
 */
function getBusinessList(params) {
  return (0, _request.default)({
    url: "/admin/companyapp/list",
    method: 'GET',
    params: params
  });
}

/**
 * 交易统计-日期选择
 * @param pram
 */
function getBusinessNData(params) {
  return (0, _request.default)({
    url: "/admin/statistics/console/getBusinessNData",
    method: 'GET',
    params: params
  });
}

/**
 * 商品统计数据
 * @param pram
 */
function getProductData(params) {
  return (0, _request.default)({
    url: "/admin/statistics/product/data",
    method: 'GET',
    params: params
  });
}

/**
 * 商品趋势数据
 * @param pram
 */
function getProductTrend(params) {
  return (0, _request.default)({
    url: "/admin/statistics/product/trend",
    method: 'GET',
    params: params
  });
}

/**
 * 商品趋势数据
 * @param pram
 */
function getProductRanking(params) {
  return (0, _request.default)({
    url: "/admin/statistics/product/ranking",
    method: 'GET',
    params: params
  });
}

/**
 * 用户统计
 * @param pram
 */
function getUserData(params) {
  return (0, _request.default)({
    url: "/admin/statistics/console/getUserData",
    method: 'GET',
    params: params
  });
}

/**
 * 用户统计
 * @param pram
 */
function getExprot(params) {
  return (0, _request.default)({
    url: "/admin/statistics/product/ranking/export",
    method: 'GET',
    params: params
  });
}

/**
 * 用户点击分析
 * @param pram
 */
function getUserClickApi(params) {
  return (0, _request.default)({
    url: "/admin/statistics/console/getUserLog",
    method: 'GET',
    params: params
  });
}

/**
 * 用户统计搜索日志列表
 * @param pram
 */
function searchMsgClickApi(params) {
  return (0, _request.default)({
    url: "/admin/statistics/console/getUserSearchLog",
    method: 'GET',
    params: params
  });
}

/**
 * 数据总览 - 购物车自营商品前五名（加购未下单 Top5）
 * GET /admin/core/overview/cart/product/top
 * @param {{ customerIds?: string }} params 多选逗号分隔
 * @returns {Promise<Array<{ cartQuantity: number, productId: number, productName: string }>>}
 */
function overviewCartProductTopApi(params) {
  return (0, _request.default)({
    url: "/admin/core/overview/cart/product/top",
    method: 'GET',
    params: params
  });
}

/** 数据总览 - 当前账号可访问的小程序范围及毛利率展示能力。 */
function overviewAccessApi() {
  return (0, _request.default)({
    url: "/admin/core/overview/access",
    method: 'GET'
  });
}

/**
 * 数据总览 - 访问用户数 / 下单订单数小时趋势
 * GET /admin/core/overview/hourly/trend
 * @param {{ customerIds?: string, date?: string }} params date 格式 yyyy-MM-dd；customerIds 多选逗号分隔
 * @returns {Promise<Array<{ hour: string, visitUserCount: number, orderCount: number }>>}
 */
function overviewHourlyTrendApi(params) {
  return (0, _request.default)({
    url: "/admin/core/overview/hourly/trend",
    method: 'GET',
    params: params
  });
}

/**
 * 数据总览 - 访问用户数 / 支付订单数小时趋势
 * GET /admin/core/overview/hourly/pay/trend
 * @param {{ customerIds?: string, date?: string }} params date 格式 yyyy-MM-dd；customerIds 多选逗号分隔
 * @returns {Promise<Array<{ hour: string, visitUserCount: number, payOrderCount: number }>>}
 */
function overviewHourlyPayTrendApi(params) {
  return (0, _request.default)({
    url: "/admin/core/overview/hourly/pay/trend",
    method: 'GET',
    params: params
  });
}

/**
 * 数据总览 - 装修页下拉（授权装修链接分页）
 * GET /admin/core/overview/design/auth/page
 * @param {{ page?: number, limit?: number, urlName?: string }} params
 */
function overviewDesignAuthPageApi(params) {
  return (0, _request.default)({
    url: "/admin/core/overview/design/auth/page",
    method: 'GET',
    params: params
  });
}

/**
 * 数据总览 - 停留时长分布
 * GET /admin/core/overview/duration/distribution
 * @param {{ customerIds?: string, designAuthId?: number|string }} params customerIds 多选逗号分隔
 * @returns {Promise<Array<{ count: number, durationRange: string, dataUpdateTime: string }>>}
 */
function overviewDurationDistributionApi(params) {
  return (0, _request.default)({
    url: "/admin/core/overview/duration/distribution",
    method: 'GET',
    params: params
  });
}

/**
 * 数据总览 - 点击量 / 浏览PV 小时趋势
 * GET /admin/core/overview/hourly/traffic/trend
 * @param {{ date?: string, customerIds?: string, designAuthId?: number|string }} params date 格式 yyyy-MM-dd；customerIds 多选逗号分隔
 * @returns {Promise<Array<{ browsePv: number, clickCount: number, hour: string, dataUpdateTime?: string }>>}
 */
function overviewHourlyTrafficTrendApi(params) {
  return (0, _request.default)({
    url: "/admin/core/overview/hourly/traffic/trend",
    method: 'GET',
    params: params
  });
}

/**
 * 数据总览 - 流量指标概况
 * GET /admin/core/overview/traffic/data
 * @param {{
 *   customerIds?: string,
 *   designAuthId?: number|string,
 *   type?: number,
 *   startTime?: string,
 *   endTime?: string,
 * }} params type: 1今日 2本周 3当月 4当年 5自定义(需 startTime/endTime)；customerIds 多选逗号分隔
 */
function overviewTrafficDataApi(params) {
  return (0, _request.default)({
    url: "/admin/core/overview/traffic/data",
    method: 'GET',
    params: params
  });
}

/**
 * 数据总览 - 交易指标概况
 * GET /admin/core/overview/transaction/data
 */
function overviewTransactionDataApi(params) {
  return (0, _request.default)({
    url: "/admin/core/overview/transaction/data",
    method: 'GET',
    params: params
  });
}

/**
 * 数据总览 - 核心用户数据
 * GET /admin/core/overview/user/data
 */
function overviewUserDataApi(params) {
  return (0, _request.default)({
    url: "/admin/core/overview/user/data",
    method: 'GET',
    params: params
  });
}